import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav"; // Correct import for Nav component
import Form from "react-bootstrap/Form"; // Correct import for Form component
import Button from "react-bootstrap/Button"; // Correct import for Button component
import FormControl from "react-bootstrap/FormControl";

function HeaderWithCount() {
  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Navbar.Brand href="#home" style={{ color: "white" }}>
          only-remote
        </Navbar.Brand>
        <Nav className="mr-auto">
          <Nav.Link as={Link} to="/" style={{ color: "white" }}>
            Remote Job
          </Nav.Link>
          <Nav.Link as={Link} to="/internships" style={{ color: "white" }}>
            Internships
          </Nav.Link>
          <Nav.Link as={Link} to="/front-end-jobs" style={{ color: "white" }}>
            frontend developer jobs
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/front-end-jobs-interns"
            style={{ color: "white" }}
          >
            frontend developer internships
          </Nav.Link>
          <Nav.Link as={Link} to="/fullstack-jobs" style={{ color: "white" }}>
            fullstack jobs
          </Nav.Link>
          <Nav.Link as={Link} to="/mern-stack-jobs" style={{ color: "white" }}>
            mern stack jobs
          </Nav.Link>
          <Nav.Link as={Link} to="/mean-stack-jobs" style={{ color: "white" }}>
            Mean stack jobs
          </Nav.Link>
          <Nav.Link as={Link} to="/node-js-jobs" style={{ color: "white" }}>
            node js jobs
          </Nav.Link>
          <Nav.Link as={Link} to="/php-jobs" style={{ color: "white" }}>
            php jobs
          </Nav.Link>
        </Nav>
      </Navbar>
    </>
  );
}

export default HeaderWithCount;
